import { Url } from 'app/utils';
import { Application } from 'app/classes';

export class Route {

    public slug: string = '/';
    public deeplink: string = '';
    public fullpath: string = '';
    public pathname: string = '';

    constructor(path: string) {
        const parsed = Url.parse(Url.wrapSlashes(path));
        const parts = parsed.pathname.split('/').filter(Boolean);
        const partial = parts.slice(1).join('/');

        const slug = parts[0] || '';
        const deeplink = Url.wrapSlashes(Url.join(partial, parsed.search));
        const fullpath = parsed.href;
        const pathname = parsed.pathname;

        this.slug = slug || this.slug;
        this.deeplink = deeplink || this.deeplink;
        this.fullpath = fullpath || this.fullpath;
        this.pathname = pathname || this.pathname;
    }

}
